import { Brand, Country, Language } from '@/domainLogic/index.ts';
import type { Localization } from './Localization';

const getFlightsUrl = (localization: Localization): string => {
  const { lang, country, brand } = localization;
  switch (lang) {
    case Language.BG:
      return 'https://bg.lastminute.com/flights';
    case Language.CS:
      return 'https://cz.lastminute.com/letenky';
    case Language.DA:
      return 'https://dk.lastminute.com/flyrejser';
    case Language.EL:
      return country === Country.CY ? 'https://cy.lastminute.com/flights' : 'https://gr.lastminute.com/flights';
    case Language.DE:
      return 'https://www.lastminute.de/flug/';
    case Language.ES:
      return brand === Brand.RUMBO ? 'https://www.rumbo.es/vuelos' : 'https://www.es.lastminute.com/vuelos/';
    case Language.ET:
      return 'https://ee.lastminute.com/lennud';
    case Language.FI:
      return 'https://fi.lastminute.com/lennot';
    case Language.FR:
      return country === Country.BE
        ? 'https://fr.lastminute.be/billet-avion/'
        : 'https://www.fr.lastminute.com/billet-avion/';
    case Language.HR:
      return 'https://hr.lastminute.com/letovi';
    case Language.HU:
      return 'https://hu.lastminute.com/repulojegy';
    case Language.IS:
      return 'https://is.lastminute.com/flug/A';
    case Language.IT:
      return brand === Brand.VOLAGRATIS ? 'https://www.volagratis.com/voli' : 'https://www.it.lastminute.com/voli/';
    case Language.LT:
      return 'https://lt.lastminute.com/skrydziai';
    case Language.LV:
      return 'https://lv.lastminute.com/lidojumi';
    case Language.NL:
      return country === Country.BE ? 'https://www.lastminute.be/vluchten' : 'https://nl.lastminute.com/vluchten';
    case Language.NO:
      return 'https://no.lastminute.com/fly';
    case Language.PL:
      return 'https://pl.lastminute.com/loty';
    case Language.PT:
      return 'https://www.rumbo.pt/voos';
    case Language.RO:
      return 'https://ro.lastminute.com/bilete-de-avion';
    case Language.SK:
      return 'https://sk.lastminute.com/letenky';
    case Language.SL:
      return 'https://si.lastminute.com/leti';
    case Language.SV:
      return 'https://se.lastminute.com/flyg';
    case Language.EN:
      return country === Country.IE ? 'https://www.lastminute.ie/flights/' : 'https://www.lastminute.com/flights/';
    default:
      return '';
  }
};

export default getFlightsUrl;
